<template>
  <div class="vue-template">
    <div class="register">
      <div class="register-card">
        <div>
          <div class="font-size-h4">{{ policy.title }}</div>
          <div class="scrollable-box mt-4">
            <div style="font-size: 12px;">{{ policy.text }}</div>
          </div>
          <div class="form-check mt-4">
            <input class="form-check-input" type="checkbox" id="flexCheckDefault" v-model="isChecked">
            <label class="form-check-label font-size-h4" for="flexCheckDefault">
              ยอมรับข้อตกลง
            </label>


          </div>

          <button type="submit" class="btn btn-create btn-lg mt-2 w-100" :disabled="!isChecked || isLoading"
            @click="acceptPolicy()">
            <div class="spinner-border spinner-border-sm text-black text-center" role="status" v-if="isLoading">
              <span class="visually-hidden">Loading...</span>
            </div>
            ยืนยัน
          </button>
          <button type="submit" class="btn bg-black btn-lg mt-2 w-100 text-white" @click="close()">
            ยกเลิก
          </button>
        </div>

      </div>
    </div>
  </div>


</template>
<script>
import axios from 'axios';
import { asidValidator } from '../helpers/asidValidator'; // Adjust the path as needed
import { phoneValidator } from '../helpers/phoneValidator'; // Adjust the path as needed

import { generateRandomAsid } from '../helpers/randomAsid'; // Adjust the path as needed

export default {
  data() {
    return {
      user: {
        email: '',

      },
      phonenumber: '',
      policy: '',
      isChecked: false, // เก็บสถานะของ checkbox
      step: 0,
      asid: '',
      errorMessage: '', // เก็บข้อความข้อผิดพลาด
      isLoading: false
    };
  },
  async created() {

    const policy = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/policy/`,);
    this.policy = policy.data.data
  }
  ,
  methods: {
    close() {
      this.$emit('close')
    },
    async acceptPolicy() {
      this.isLoading = true
      this.$emit('acceptPolicy')
    },

  }
};
</script>

<style>
.scrollable-box {
  height: 320px;
  /* กำหนดความสูงของกรอบ */
  overflow-y: auto;
  /* เพิ่มการเลื่อนในแนวตั้ง */
  padding: 10px;
  border: 1px solid #ddd;
  /* เส้นขอบ */
  /* ขอบมน */
  background-color: #f9f9f9;
  /* พื้นหลัง */
  /* เงา */
}

.register-card {
  background-color: #fff;
  border-radius: 20px;

  /* padding: 15em; */
  justify-content: center;
  /* จัดเนื้อหาใน card แนวนอน */
  align-items: center;
  /* จัดเนื้อหาใน card แนวตั้ง */
  /* เพิ่มเงา */
}

.text-danger {
  color: red;
  font-size: 14px;
}

.register {
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 95vh; */
  width: 100%;

}
</style>